import ApiService from './ApiService';

export default class OptionApi extends ApiService {
    constructor() {
        super('');
    }

    getOptions(payload) {
        return this.get('system/optionals', payload);
    }

    createOption(payload) {
        return this.post('system/optionals', payload);
    }

    getOptionById(optionId) {
        return this.get(`system/optionals/${optionId}`);
    }

    updateOption(data) {
        const { optionId, payload } = data;
        return this.put(`system/optionals/${optionId}`, payload);
    }

    deleteOption(optionId) {
        return this.delete(`system/optionals/${optionId}`);
    }

    getOptionsEnduser(payload) {
        return this.get('optionals', payload);
    }
}
